import AirConditioning from './airConditioning.png';
import Blinds from './blinds.png';
import Electricians from './electrician.png';
import KitchenRenovations from './kitchenRenovations.png';
import LandscapeRenovations from './landscapeSupplies.png';
import LawnMowingServices from './lawnMowingServices.png';
import MedicalCentre from './medicalCentre.png';
import PestControl from './pestControl.png';
import Physiotherapy from './physiotherapy.png';
import Restaurants from './restaurants.png';
import Solicitors from './solicitors.png';
import Tyres from './tyres.png';
import Florists from './florist.png';
import Roofing from './roofing.png';
import Removalist from './removalist.png';
import Locksmith from './locksmiths.png';
import Carpet from './carpetcleaning.png';
import Cafes from './cafes.png';
import Plumbers from './plumbers.png';
import Hairdressers from './hairdressers.png';
import Pubs from './pubs.png';
import Mechanics from './mechanics.png';
import Massage from './massageTherapists.png';
import Auto from './autoWreckers.png';

export {
  AirConditioning,
  Blinds,
  Electricians,
  KitchenRenovations,
  LandscapeRenovations,
  LawnMowingServices,
  MedicalCentre,
  PestControl,
  Physiotherapy,
  Restaurants,
  Solicitors,
  Tyres,
  Florists,
  Removalist,
  Locksmith,
  Roofing,
  Carpet,
  Cafes,
  Plumbers,
  Hairdressers,
  Pubs,
  Mechanics,
  Massage,
  Auto,
};
